globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import Script from 'next/script';
import { createGlobalStyle } from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CustomIubendaCss = /*#__PURE__*/createGlobalStyle(["#iubenda-cs-banner .iubenda-cs-opt-group button.iubenda-cs-btn-primary,#iubenda-cs-banner .iubenda-cs-customize-btn{border-radius:8px !important;}#iubenda-cs-banner .iubenda-cs-opt-group button.iubenda-cs-reject-btn{border:2px solid #BCCF00 !important;}"]);
var isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export var IubendaProvider = function IubendaProvider(_ref) {
  var children = _ref.children;
  if (!isProd) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Script, {
      id: "iubenda-config",
      children: "var _iub = _iub || [];_iub.csConfiguration = {\"askConsentAtCookiePolicyUpdate\":true,\"cookiePolicyInOtherWindow\":true,\"perPurposeConsent\":true,\"siteId\":3424432,\"cookiePolicyId\":25144422,\"lang\":\"it\",\"cookiePolicyUrl\":\"https://www.restworld.it/cookie-policy\", \"banner\":{ \"acceptButtonCaptionColor\":\"#2B174F\",\"acceptButtonColor\":\"#D0E124\",\"acceptButtonDisplay\":true,\"backgroundColor\":\"#F6F5FF\",\"brandBackgroundColor\":\"#F6F5FF\",\"brandTextColor\":\"#000000\",\"closeButtonDisplay\":false,\"customizeButtonCaptionColor\":\"#000000\",\"customizeButtonColor\":\"#FFFFFF\",\"customizeButtonDisplay\":true,\"explicitWithdrawal\":true,\"listPurposes\":true,\"logo\":\"https://restworld-illustrations.fra1.cdn.digitaloceanspaces.com/logo/Viola_scuro_oriz.png\",\"linksColor\":\"#1C1327\",\"position\":\"float-bottom-left\",\"rejectButtonCaptionColor\":\"#2B174F\",\"rejectButtonColor\":\"#EEFAA6\",\"rejectButtonDisplay\":true,\"showTitle\":false,\"textColor\":\"#1C1327\" }};"
    }), /*#__PURE__*/_jsx(Script, {
      src: "https://cs.iubenda.com/autoblocking/3424432.js"
    }), /*#__PURE__*/_jsx(Script, {
      src: "//cdn.iubenda.com/cs/gpp/stub.js"
    }), /*#__PURE__*/_jsx(Script, {
      src: "//cdn.iubenda.com/cs/iubenda_cs.js",
      async: true
    }), /*#__PURE__*/_jsx(CustomIubendaCss, {}), children]
  });
};